// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TimeSvg from '@rsuite/icon-font/lib/time/Time';
var Time = createSvgIcon({
    as: TimeSvg,
    ariaLabel: 'time',
    category: 'time',
    displayName: 'Time'
});
export default Time;
